import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationMessages {
  validationMessages = {
    first_name: [
      {
        type: 'nameRequerid',
        message: 'Los nombres son requeridos.'
      },
      {
        type: 'nameText',
        message: 'Los nombres sólo deben contener letras.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 2 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 50 caracteres.'
      }
    ],
    last_name: [
      {
        type: 'nameRequerid',
        message: 'Los apellidos son requeridos.'
      },
      {
        type: 'nameText',
        message: 'Los apellidos sólo deben contener letras.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 50 caracteres.'
      }
    ],
    identification: [
      {
        type: 'nameRequerid',
        message: 'La cédula es requerida.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una cédula válida.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 15 caracteres.'
      },
    ],
    tuition: [
      {
        type: 'nameRequerid',
        message: 'La matrícula es requerida.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una matrícula válida.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 15 caracteres.'
      }
    ],
    ced_user: [
      {
        type: 'nameRequerid',
        message: 'La cédula es requerida.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una cédula válida.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 15 caracteres.'
      }
    ],
    gender: [
      {
        type: 'nameRequerid',
        message: 'El género es requerido.'
      },
      {
        type: 'required',
        message: 'El género es requerido.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una género válido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 30 caracteres.'
      }
    ],
    day: [
      {
        type: 'nameRequerid',
        message: 'La fecha de nacimiento es requerida.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una fecha de nacimiento válida.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 30 caracteres.'
      }
    ],
    email: [
      {
        type: 'nameRequerid',
        message: 'El correo electrónico es requerido.'
      },
      {
        type: 'nameText',
        message: 'Ingrese un correo electrónico válido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 50 caracteres.'
      }
    ],
    state_name: [
      {
        type: 'nameRequerid',
        message: 'La provincia es requerida.'
      },
      {
        type: 'required',
        message: 'La provincia es requerida.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una provincia válida.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 30 caracteres.'
      }
    ],
    city_name: [
      {
        type: 'nameRequerid',
        message: 'La localidad es requerida.'
      },
      {
        type: 'required',
        message: 'La localidad es requerida.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una localidad válida.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 30 caracteres.'
      }
    ],
    city_id: [
      {
        type: 'nameRequerid',
        message: 'La localidad es requerida.'
      },
      {
        type: 'required',
        message: 'La localidad es requerida.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una localidad válida.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 30 caracteres.'
      }
    ],
    address: [
      {
        type: 'nameRequerid',
        message: 'La dirección es requerida.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una dirección válida.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 100 caracteres.'
      }
    ],
    code_country_cell_phone: [
      {
        type: 'nameRequerid',
        message: 'El código de teléfono es requerido.'
      },
      {
        type: 'nameText',
        message: 'Ingrese un código de teléfono válido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 1 carácter.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 3 caracteres.'
      }
    ],
    prefix_cell_phone: [
      {
        type: 'nameRequerid',
        message: 'El prefijo es requerido.'
      },
      {
        type: 'nameText',
        message: 'Ingrese un prefijo válido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 1 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 6 caracteres.'
      }
    ],
    cell_phone: [
      {
        type: 'nameRequerid',
        message: 'El teléfono es requerido.'
      },
      {
        type: 'nameText',
        message: 'Ingrese un teléfono válido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 6 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 15 caracteres.'
      }
    ],
    phone_number_2: [
      {
        type: 'nameRequerid',
        message: 'El teléfono es requerido.'
      },
      {
        type: 'nameText',
        message: 'Ingrese un teléfono válido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 6 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 15 caracteres.'
      }
    ],
    code_country_cell_phone2: [
      {
        type: 'nameRequerid',
        message: 'El código de teléfono es requerido.'
      },
      {
        type: 'nameText',
        message: 'Ingrese un código de teléfono válido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 1 carácter.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 3 caracteres.'
      }
    ],
    prefix_cell_phone2: [
      {
        type: 'nameRequerid',
        message: 'El prefijo es requerido.'
      },
      {
        type: 'nameText',
        message: 'Ingrese un prefijo válido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 1 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 6 caracteres.'
      }
    ],
    prefix_2: [
      {
        type: 'nameRequerid',
        message: 'El prefijo es requerido.'
      },
      {
        type: 'nameText',
        message: 'Ingrese un prefijo válido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 1 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 6 caracteres.'
      }
    ],
    cell_phone_2: [
      {
        type: 'nameRequerid',
        message: 'El teléfono es requerido.'
      },
      {
        type: 'nameText',
        message: 'Ingrese un teléfono válido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 6 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 15 caracteres.'
      }
    ],
    pathology_id: [
      {
        type: 'nameRequerid',
        message: 'La patología es requerida.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una patología válida.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 30 caracteres.'
      }
    ],
    checkCategory: [
      {
        type: 'nameRequerid',
        message: 'La marcación de este campo es requerida.'
      }
    ],
    //kits
    state_id: [
      {
        type: 'nameRequerid',
        message: 'La provincia es requerida.'
      },
      {
        type: 'required',
        message: 'La provincia es requerida.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una provincia válida.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 30 caracteres.'
      }
    ],
    first_hour: [
      {
        type: 'required',
        message: 'La hora inicial es requerida.'
      }
    ],
    last_hour: [
      {
        type: 'required',
        message: 'La hora final es requerida.'
      }
    ],
    note: [
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 2 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 150 caracteres.'
      }
    ],
    name: [
      {
        type: 'nameRequerid',
        message: 'El nombre es requerido.'
      },
      {
        type: 'nameText',
        message: 'El nombre sólo debe contener letras.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 50 caracteres.'
      }
    ],
    count_patient: [
      {
        type: 'min',
        message: 'Seleccione una cantidad mayor a 0.'
      },
      {
        type: 'nameRequerid',
        message: 'La cantidad de pacientes es requerida.'
      },
      {
        type: 'nameText',
        message: 'Ingrese una cantidad válida.'
      },
      {
        type: 'nameNumberMax',
        message: 'Seleccione una cantidad entre 1 y 99 pacientes.'
      }
    ],
    day_hour: [
      {
        type: 'nameRequerid',
        message: 'El dia es requerido.'
      }
    ],
    get_day: [
      {
        type: 'nameRequerid',
        message: 'El dia es requerido.'
      }
    ],
    get_init_hour: [
      {
        type: 'nameRequerid',
        message: 'la hora inicial es requerida.'
      }
    ],
    get_end_hour: [
      {
        type: 'nameRequerid',
        message: 'la hora final es requerida.'
      }
    ],
    address_id: [
      {
        type: 'nameRequerid',
        message: 'El lugar de retiro es requerido.'
      }
    ],
    institution_name: [
      {
        type: 'nameRequerid',
        message: 'El lugar de entrega es requerido.'
      }
    ],
    institution: [
      {
        type: 'nameRequerid',
        message: 'La institución es requerida.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 50 caracteres.'
      }
    ],
    name_contact: [
      {
        type: 'nameRequerid',
        message: 'El nombre es requerido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 50 caracteres.'
      },
      {
        type: 'nameText',
        message: 'El nombre sólo debe contener letras.'
      }
    ],
    prefix: [
      {
        type: 'nameRequerid',
        message: 'El prefijo es requerido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe tener más de 1 carácter.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 6 caracteres.'
      },
      {
        type: 'nameText',
        message: 'Ingrese un prefijo válido.'
      }
    ],
    phone_number: [
      {
        type: 'nameRequerid',
        message: 'El teléfono es requerido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe tener más de 6 carácter.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 15 caracteres.'
      },
      {
        type: 'nameText',
        message: 'Ingrese un teléfono válido.'
      }
    ],
    study: [
      {
        type: 'required',
        message: 'El tipo de estudio es requerido.'
      }
    ],
    type_study: [
      {
        type: 'nameRequerid',
        message: 'El tipo de estudio es requerido.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe tener máximo 60 caracteres.'
      }
    ],
    count_gather: [
      {
        type: 'nameRequerid',
        message: 'La cantidad de muestras es requerida.'
      }
    ],
    rol_id: [
      {
        type: 'nameRequerid',
        message: 'El rol es requerido.'
      }
    ],
    password: [
      {
        type: 'nameRequerid',
        message: 'La contraseña es obligatoria.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe tener más de 6 carácter.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 15 caracteres.'
      },
      {
        type: 'nameText',
        message: 'La contraseña debe tener una minúscula, una mayúscula, y un número.'
      }
    ],
    new_password: [
      {
        type: 'nameRequerid',
        message: 'La nueva contraseña es obligatoria.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe tener más de 6 carácter.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 15 caracteres.'
      },
      {
        type: 'nameText',
        message: 'La contraseña debe tener una minúscula, una mayúscula, y un número.'
      }
    ],
    confirm_password: [
      {
        type: 'nameRequerid',
        message: 'La contraseña es obligatoria.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe tener más de 6 carácter.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 15 caracteres.'
      }
    ],
    comment: [
      {
        type: 'nameNumberMax',
        message: 'Debe tener máximo 100 caracteres.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe tener más de 2 caracteres.'
      }
    ],
    postal: [
      {
        type: 'nameRequerid',
        message: 'El código postal es requerido.'
      },
      {
        type: 'nameText',
        message: 'El código postal no es valido.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 8 caracteres.'
      }
    ],
    observation: [
      {
        type: 'nameRequerid',
        message: 'Las observaciones son requeridas.'
      },
      {
        type: 'nameText',
        message: 'Las observaciones no son validas.'
      },
      {
        type: 'nameNumberMin',
        message: 'Debe de tener más de 3 caracteres.'
      },
      {
        type: 'nameNumberMax',
        message: 'Debe de tener máximo 50 caracteres.'
      }
    ],
    familySuspicion: [
      {
        type: 'required',
        message: 'Este campo es requerido.'
      }
    ],
  }
}
